<template>
    <span class="has-popover" :class="variant ? 'variant-' + variant : ''">
        <slot></slot>
        <div class="ss-popover">
            <div class="popover-content">
                <slot name="tooltip"></slot>
            </div>
            <i class="arrow"></i>
        </div>
    </span>
</template>

<script>
    export default {
        name: "SsPopover",
        props: {
            variant: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style lang="scss">
    .has-popover {
        position: relative;

        &:hover {
            z-index: 99;
            .ss-popover {
                opacity: 1;
            }
        }
        &.variant-right{
            .ss-popover{
                transform: translate(-12px, 0);
                border-bottom-left-radius: 0;
                &:after, &::before, .arrow {
                    left: 12px;
                }
            }
        }
        &.variant-left{
            .ss-popover{
                transform: translate(-100%, 0);
                border-bottom-right-radius: 0;
                margin-left: 24px;
                &:after, &::before, .arrow {
                    right: 12px;
                    left: auto;
                }
            }
        }
        .ss-popover {
            opacity: 0;
            pointer-events: none;
            position: absolute;
            bottom: 100%;
            left: 50%;
            min-width: 272px;
            padding: 15px;
            font-weight: normal;
            color: #000;
            text-align: center;
            border: 1px solid #d8d7d7;
            font-size: 14px;
            background-color: white;
            border-radius: 4px;
            -webkit-box-shadow: 10px 10px 1px 0px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: 10px 10px 1px 0px rgba(0, 0, 0, 0.3);
            box-shadow: 10px 10px 1px 0px rgba(0, 0, 0, 0.3);
            transform: translate(-50%, 0);
            -webkit-transition: all 0.3s ease;
            -moz-transition: all 0.3s ease;
            -ms-transition: all 0.3s ease;
            -o-transition: all 0.3s ease;
            transition: all 0.3s ease;
            .popover-content{
                &:before, &:after{
                content: '';
                display: table;
                width: 100%;
                clear: both;
                }
            }
            &:after, &::before, .arrow {
                content: '';
                position: absolute;
                top: 100%;
                left: 50%;
                margin-left: -11px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 12px 11px 0 11px;
                border-color: #d8d7d7 transparent transparent transparent;
            }
            &:after {
                margin-top: -1px;
                border-color: white transparent transparent transparent;
                z-index: 2;
            }
            .arrow {
                border-color: rgba(0, 0, 0, 0.2) transparent transparent transparent;
                margin-top: 10.5px;
                margin-left: 0;
            }
        }
    }
</style>
